import { ClientDirectory, ClientOverview, ClientQuoteList, ClientSummaryState } from '@cockpit/shared';
import { request } from './client';

/**
 * Lot AV « Page client », à part de `api/index.ts` : recherche de l'en-tête, page entière, résumé de l'assistant.
 */
export const clientsApi = {
  /** Tous les clients (nom, commune, relation) pour la recherche de l'en-tête. */
  directory: () => request('GET', '/api/clients/directory', { schema: ClientDirectory }),
  /** Lot AX : devis du client (copie locale d'Axonaut), du plus récent au plus ancien (« Devis déjà fait »). */
  quotes: (clientId: string) =>
    request('GET', `/api/clients/${encodeURIComponent(clientId)}/quotes`, { schema: ClientQuoteList }),
  overview: (clientId: string) =>
    request('GET', `/api/clients/${encodeURIComponent(clientId)}/overview`, { schema: ClientOverview }),
  /** Résumé de l'assistant : refait s'il a plus de 24 h, ou toujours avec `force` (« Rafraîchir »). */
  summary: (clientId: string, force = false) =>
    request('POST', `/api/clients/${encodeURIComponent(clientId)}/summary`, {
      body: { force },
      schema: ClientSummaryState,
    }),
};
